import type { AppStore } from "@/store/AppStore";
import type {
  GetAssistantProjectInput,
  GetAssistantProjectOutput,
} from "@mem-client/ai-toolkit/contract";
import {
  AiToolkitToolName,
  getAssistantProjectInputSchema,
  getAssistantProjectOutputSchema,
} from "@mem-client/ai-toolkit/contract";
import { AiToolkitAssistantProjectNotFoundError } from "@/modules/ai-toolkit/errors";
import type { AiToolkitToolDefinition } from "@/modules/ai-toolkit/tools/types";
import {
  buildAssistantProjectFromCreateChangeRequestUpdateValue,
  buildAssistantProjectFromSyncUpdateValue,
  isCreateProjectChangeRequestUpdateValue,
} from "@/modules/ai-toolkit/tools/assistant-projects/assistant-project-tools.helpers";

export const getAssistantProject = async ({
  store,
  input,
}: {
  store: AppStore;
  input: GetAssistantProjectInput;
}): Promise<GetAssistantProjectOutput> => {
  const projectRow = await store.assistantProjects.localTable.get(input.projectId);

  if (projectRow) {
    return {
      project: buildAssistantProjectFromSyncUpdateValue({ updateValue: projectRow }),
    };
  }

  const changeRequestRow = await store.assistantProjectChangeRequests.localTable.get(
    input.projectId
  );

  if (
    !changeRequestRow ||
    !isCreateProjectChangeRequestUpdateValue({ updateValue: changeRequestRow })
  ) {
    throw new AiToolkitAssistantProjectNotFoundError({ projectId: input.projectId });
  }

  return {
    project: buildAssistantProjectFromCreateChangeRequestUpdateValue({
      updateValue: changeRequestRow,
    }),
  };
};

export const getAssistantProjectTool: AiToolkitToolDefinition<
  AiToolkitToolName.GetAssistantProject,
  GetAssistantProjectInput,
  GetAssistantProjectOutput
> = {
  name: AiToolkitToolName.GetAssistantProject,
  inputSchema: getAssistantProjectInputSchema,
  outputSchema: getAssistantProjectOutputSchema,
  strict: true,
  execute: getAssistantProject,
};
